import React from 'react'
import {Breadcrumbs, Link, Typography} from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

import './index.scss'

interface BreadcrumbProps {
    list?: unknown[]
}

const Breadcrumb = ({list}: BreadcrumbProps) => (
    <Breadcrumbs
        separator={<NavigateNextIcon className='separator' fontSize='small' />}
        aria-label='breadcrumb'
        className='cps-breadcrumb'
    >
        {list?.map((item: any, index) => {
            if (index !== list.length - 1) {
                return (
                    <Link key={index} href={item?.path}>
                        {item?.label}
                    </Link>
                )
            } else {
                return (
                    <Typography key={index} variant='h6'>
                        {item.label}
                    </Typography>
                )
            }
        })}
    </Breadcrumbs>
)

export default Breadcrumb
